import { useRequest } from 'ahooks';
import { atom, useAtomValue, useSetAtom } from 'jotai';
import { updateSeedSku, UpdateSeedSkuBody } from 'services/api/supplementKnowledge';

// 临时存放扩展商品计算中状态
const expandInCalculationState = atom<number[]>([]);

const useExpandInCalculation = () => useAtomValue(expandInCalculationState);
const useSetExpandInCalculation = () => useSetAtom(expandInCalculationState);

export const useCleanExpandInCalculation = () => {
  const setExpandInCalculation = useSetExpandInCalculation();
  return () => setExpandInCalculation([]);
};

export const useIsExpandInCalculation = () => {
  const expandInCalculation = useExpandInCalculation();
  return (knowledgeId: number) => expandInCalculation.includes(knowledgeId);
};

/**
 * 更新种子sku
 */
export const useUpdateSeekSku = (props: { onRefresh?: () => void }) => {
  const { onRefresh } = props;

  const setExpandInCalculation = useSetExpandInCalculation();

  const { runAsync: updateAsync } = useRequest(
    async (body: UpdateSeedSkuBody) => {
      const response = await updateSeedSku(body);
      setExpandInCalculation((prev) => [...prev, body.knowledgeId]);
      return response;
    },
    {
      manual: true,
      onSuccess: () => {
        onRefresh?.();
      },
    },
  );

  return {
    updateAsync,
  };
};
